angular
.module('empower.claimPerformanceReport')
.directive('cprTable', [function () {
    return {
        restrict: 'E',
        templateUrl: 'module/report/view/cpr-table.html',
        scope: {
            cprSection: '=',
            noData: '='
        }
    }
}]);